export class TwoFactorError extends Error {}
